import { render, staticRenderFns } from "./sidongCard.vue?vue&type=template&id=4104bb6e&scoped=true&"
import script from "./sidongCard.vue?vue&type=script&lang=js&"
export * from "./sidongCard.vue?vue&type=script&lang=js&"
import style0 from "./sidongCard.vue?vue&type=style&index=0&id=4104bb6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4104bb6e",
  null
  
)

export default component.exports